import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import MapIcon from "@material-ui/icons/Map";
// v4's icon set (@material-ui/icons ^4.11.2) predates a few Material Symbols used by the
// original v5 design (MonitorHeart, CarCrash) — closest available equivalents substituted.
import DashboardIcon from "@material-ui/icons/Dashboard";
import MemoryIcon from "@material-ui/icons/Memory";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import styles from "./index.module.css";
import { FleetNavId } from "./types";
import { LiveMap } from "./LiveMap";
import { IndicatorsPage } from "./IndicatorsPage";
import { DTCPage } from "./DTCPage";
import { CrashPage } from "./CrashPage";
import { useTrackedVehicles } from "./useTrackedVehicles";

const NAV_ITEMS: Array<{ id: FleetNavId; label: string; Icon: typeof MapIcon }> = [
  { id: "livemap", label: "Live Map", Icon: MapIcon },
  { id: "indicators", label: "Indicators", Icon: DashboardIcon },
  { id: "dtc", label: "DTC", Icon: MemoryIcon },
  { id: "crash", label: "Crash", Icon: ReportProblemIcon },
];

export default function FleetDashboardV2() {
  const [activeNav, setActiveNav] = useState<FleetNavId>("livemap");
  const { vehicles, loading, totalCount, onlineCount } = useTrackedVehicles();

  return (
    <Box className={styles.screen}>
      <nav className={styles.iconNav}>
        {NAV_ITEMS.map(({ id, label, Icon }) => {
          const active = activeNav === id;
          return (
            <button
              key={id}
              title={label}
              onClick={() => setActiveNav(id)}
              className={`${styles.iconNavBtn} ${active ? styles.iconNavBtnActive : ""}`}
            >
              <Icon style={{ fontSize: 22 }} />
              <Typography component="span" className={styles.iconNavLabel}>{label}</Typography>
            </button>
          );
        })}
      </nav>

      <Box className={styles.mainContent}>
        {activeNav === "livemap" && (
          <LiveMap
            vehicles={vehicles}
            loading={loading}
            totalCount={totalCount}
            onlineCount={onlineCount}
          />
        )}
        {activeNav === "indicators" && <IndicatorsPage vehicles={vehicles} loading={loading} />}
        {activeNav === "dtc" && <DTCPage vehicles={vehicles} loading={loading} />}
        {activeNav === "crash" && <CrashPage vehicles={vehicles} loading={loading} />}
      </Box>
    </Box>
  );
}
